import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { zodResolver } from '@hookform/resolvers/zod';

import { useForm } from 'react-hook-form';
import { z } from 'zod';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { useImages } from '@/lib/api/images';

export const ChangeImageSchema = z.object({
  imageUrl: z.string().nonempty('Image is required'),
});

export type ChangeImageRequest = z.infer<typeof ChangeImageSchema>;

export function ChangeImageForm({ onSubmit, onChancel }: any) {
  const [values] = useImages();

  const form = useForm({
    resolver: zodResolver(ChangeImageSchema),
    defaultValues: {
      imageUrl: '',
    },
  });

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(async (data) => {
          const { imageUrl } = data;
          const imageName = new URL(imageUrl).pathname.split('/').pop();
          onSubmit({ imageUrl: imageName });
        })}
        className="space-y-6"
      >
        <FormField
          control={form.control}
          name="imageUrl"
          render={({ fieldState }) => (
            <FormItem>
              <FormLabel>Image</FormLabel>
              <FormControl>
                <Select
                  onValueChange={(value) =>
                    form.setValue('imageUrl', value, {
                      shouldDirty: true,
                      shouldValidate: true,
                      shouldTouch: true,
                    })
                  }
                  defaultValue={form.watch('imageUrl')}
                >
                  <SelectTrigger isError={!!form.formState.errors.imageUrl}>
                    <SelectValue placeholder="Select image" />
                  </SelectTrigger>
                  <SelectContent>
                    {values?.map((image) => (
                      <SelectItem key={image.url} value={image.url!}>
                        {image.name}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              </FormControl>
              <FormMessage>{fieldState.error?.message || ''}</FormMessage>
              {form.watch('imageUrl') && (
                <img
                  src={form.watch('imageUrl')}
                  alt="Preview"
                  className="mt-2 h-full rounded"
                />
              )}
            </FormItem>
          )}
        />

        <div className="flex gap-4 justify-end">
          <Button type="button" variant="outline" onClick={onChancel}>
            Cancel
          </Button>
          <Button type="submit">Submit</Button>
        </div>
      </form>
    </Form>
  );
}
